/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component} from '@angular/core';

@Component({
  standalone: false,
  selector: 'adn-release-notes-edit-title',
  template: `
    <div class="breadcrumbContainer">
      <a uiSref="app.simple.release-notes">Back to release notes list</a>
    </div>
    <adn-state-title></adn-state-title>
  `
})
export class ReleaseNotesEditTitleComponent {
}
